import React, { useState } from "react";
import "../../App.css";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import PersonalDetails from "./sections/PersonalDetails";
import MusicDetails from "./sections/MusicDetails";
import Preview from "./sections/Preview";
// import { useProfileImage, useOnboarding } from "../../store/state";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { database, auth, storage } from "../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import {Link, Redirect,withRouter} from "react-router-dom";
import { toast } from 'react-toastify';
import LogoTop from "../../components/LogoTop";
import profileActions from "../../redux/profile/actions";
import { useDispatch } from "react-redux";
import firebase from "firebase";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  layout: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    padding: theme.spacing(2),
    margin: theme.spacing(2),
    justifyContent: "center",
    alignSelf: "center",
    width: "90%",
    [theme.breakpoints.up(-800 + theme.spacing(3) * 6)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(-3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: 50,

  },
}));

const notify = () => toast.error('', {
  position: "bottom-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
});

const steps = ["Personal details", "Music details", "Review your profile"];

function getStepContent(step, file,setFile) {
  switch (step) {
    case 0:
      return <PersonalDetails />;
    case 1:
      return <MusicDetails />;
    case 2:
      return <Preview file={file} fileHandler={setFile} />;
    default:
      throw new Error("Unknown step");
  }
}

function SignUpFlow(props) {
  const classes = useStyles();
  const [file,setFile] = useState(null);
  const [userSignedIn, loading, error] = useAuthState(auth);

  if(userSignedIn){
    setTimeout(()=> <Redirect to='/my-profile'/>,3000)
  }

  const [activeStep, setActiveStep] = useState(0);

  const userNameRegExp =
      /^[a-zA-Z0-9]+$/;
  const validationSchema = [
    //validation for step1
    yup.object({
      username: yup
          .string()
          .required()
          .matches(userNameRegExp, "Username is not valid"),
      email: yup.string().email().required(),
      firstName: yup.string().required(),
      lastName: yup.string().required(),
      location: yup.string().required(),
      gender: yup.string().required(),
      password: yup.string().required("Password is required"),
      passwordConfirmation: yup.string().oneOf(
          [yup.ref("password"), null],
          "Passwords must match"
      ),
    }),
    //validation for step2
    yup.object({
      accountType: yup.string().required(),
      genres: yup.array().required(),
      description: yup.string().required(),
    }),
    yup.object({}),
  ];
  const currentValidationSchema = validationSchema[activeStep];

  const methods = useForm({
    shouldUnregister: false,
    resolver: yupResolver(currentValidationSchema),
  });

  const { control, handleSubmit, trigger, getValues, setError } = methods;

  const onSubmit = async () => {
    const {
      username,
      email,
      password,
      description,
      firstName,
      genres,
      gender,
      accountType,
      lastName,
      location,
    } = getValues();

    let userDetails = {
      bio:description,
      firstName,
      lastName,
      fullName: firstName + '' + lastName,
      location,
      gender,
      username,
      email,
    };

    let MusicDetails = { genre: genres.toString(), accountType , genres };

    let profileImage = null

    auth
        .createUserWithEmailAndPassword(email, password)
        .then((userCredential) => {
          // Signed in
          var user = userCredential.user;
          let allInfo = {
            ...userDetails,
            ...MusicDetails,
            uid: user.uid,
            signUpComplete: true,
            createdAt: firebase.database.ServerValue.TIMESTAMP
          };
          // ...
          storage
              .ref("profile_images/" + user.uid)
              .put(file)
              .then((snapshot) => {
                snapshot.ref
                    .getDownloadURL()
                    .then(function (downloadURL) {
                      profileImage = downloadURL;
                      user
                          .updateProfile({ photoURL: downloadURL })
                          .then(function () {
                          })
                          .catch(function (error) {
                            toast.error(error, {autoclose: false});
                          });
                    })
                    .then(() => {
                      database
                          .ref("users/" + user.uid)
                          .update({ ...allInfo, profileImageUrl: profileImage });
                      toast.info("  ℹ️ Welcome to your new profile", {autoclose: false});
                      setActiveStep((prevActiveStep) => prevActiveStep + 1);
                    })
                    .then(() => {
                      setTimeout(() => window.location.reload(), 2000)
                    })
              });
        })
        .catch((err) =>
            toast.error(err.message, {autoclose: false}));
  };

  const handleNext = async () => {
    const isStepValid = await trigger();
    if (isStepValid) setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const ProfileCreated = () => (
  <>

        <Redirect to="/my-profile" />
      </>
  );

  // if (!user) return <Redirect to="login" />;

  return (
      <div style={{display:'flex',justifyContent:'column'}}>
        <LogoTop></LogoTop>
        <div
            className="col-lg-5 d-none d-lg-block p-0 min-vh-100 bg-image-cover bg-no-repeat bg-pos-center bg-dark"
            style={{ background: "url(./assets/images/register-bg.jpg)" }}
        />
        <Paper className={classes.paper}>
          <h2 className="fw-bold mb-3">
            Create <br />
            your account
          </h2>
          <Stepper activeStep={activeStep} className={classes.stepper}>
            {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>

                </Step>
            ))}
          </Stepper>

          <>
            {activeStep === steps.length ? (
                <ProfileCreated />
            ) : (
                <>
                  <FormProvider {...methods}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      {getStepContent(activeStep, file, setFile)}
                      <div className={classes.buttons}>
                        <div className="form-group mb-1">
                          {activeStep !== 0 && (
                              <Button
                                  variant="contained"
                                  color="primary"
                                  type="button"
                                  onClick={handleBack}
                                  className="btn btn-lg btn-primary rounded-pill1 w-30 m-3"
                              >
                                Back
                              </Button>
                          )}

                          {activeStep === steps.length - 1 ? (
                              <Button
                                  variant="contained"
                                  color="primary"
                                  type="button"
                                  onClick={onSubmit}
                                  className="btn btn-lg btn-primary rounded-pill1 w-30 m-3"
                              >
                                Create Account
                              </Button>
                          ) : (
                              <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={handleNext}
                                  className="btn btn-lg btn-primary rounded-pill1 w-30 m-3"
                              >
                                Next
                              </Button>
                          )}
                        </div>
                      </div>
                    </form>
                  </FormProvider>
                </>
            )}
          </>
        </Paper>

        {/*<Footer />*/}
      </div>
  );
}


export default  withRouter(SignUpFlow)